package com.macrofocus.nastac.ui

import com.macrofocus.nastac.DataLoader
import com.macrofocus.nastac.components.Introduction
import com.macrofocus.nastac.components.Query
import com.macrofocus.nastac.components.Replication
import com.macrofocus.nastac.components.TimeSeries
import com.macrofocus.nastac.theme.ThemeContext
import com.macrofocus.nastac.ui.react.toState
import external.mosaic.MosaicParent
import external.mosaic.MosaicWindow
import external.mosaic.MosaicWindowProps
import external.mosaic.mosaic
import js.objects.unsafeJso
import react.*
import react.dom.html.ReactHTML.div
import web.dom.document

enum class Windows {
    Introduction,
    Query,
    Geography,
    TimeSeries,
    Replication
}

external interface EFluxProps : Props {
    var dataLoader: DataLoader
}

val EFluxApp = FC<EFluxProps> { props ->
    var theme by use(ThemeContext)!!
    val paletteType = if (theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light

    val (viewStyle, setViewStyle) = props.dataLoader.viewStyleSelection.toState()

    val (currentNode, setCurrentNode) = useState<MosaicParent<Windows>?>(
        props.dataLoader.viewStyleSelection.value.mosaicParent
    )

    useEffect(viewStyle) {
        setCurrentNode(viewStyle.mosaicParent)
    }

    val element = buildElement {
        mosaic<Windows> {
            var theme by use(ThemeContext)!!
            val paletteType = if (theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light

            attrs.value = currentNode
            attrs.onChange = { newNode ->
                println("onChange: $newNode")
                setCurrentNode(newNode as MosaicParent<Windows>?)
            }
            attrs.className =
                if (paletteType == PaletteType.dark) "mosaic mosaic-blueprint-theme bp3-dark" else "mosaic mosaic-blueprint-theme bp3-light"
            attrs.zeroStateView = document.createElement("div")
            attrs.resize = js("{\"minimumPaneSizePercentage\": 1}")

            val (country, _) = props.dataLoader.countrySelection.toState()

            attrs.renderTile = { window, path ->
                // TODO: Ugh, are there more idiomatic ways to do any of this? Yes! buildElement {}

                createElement(
                    MosaicWindow,
                    unsafeJso<MosaicWindowProps<Windows>> {
                        this.draggable = window != Windows.Introduction
                        this.title = if(window == Windows.TimeSeries && country != null) "Territorial growth of $country" else if(window == Windows.Geography) null else window.name
                        if (window != Windows.TimeSeries) {
                            this.renderToolbar = { props, _ ->
                                undefined
                            }
                        }
                        this.path = path
                    },

                    createElement(
                        div, unsafeJso {},
                        when (window) {
                            Windows.Introduction -> {
                                Introduction.create {
                                    this.dataLoader = props.dataLoader
                                }
                            }
                            Windows.Query -> {
                                Query.create {
                                    this.dataLoader = props.dataLoader
                                }
                            }
                            Windows.Geography -> {
                                ThreeD.create {
                                    this.dataLoader = props.dataLoader
                                    this.show = true
                                }
                            }
                            Windows.TimeSeries -> {
//                                Typography.create {
//                                    +"Time series"
//                                }
                                TimeSeries.create() {
                                    this.dataLoader = props.dataLoader
                                }
                            }
                            Windows.Replication -> {
                                Replication.create() {
                                    this.dataLoader = props.dataLoader
                                }
                            }
                        }
                    )
                )
            }
        }
    }
    +element
}


